var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UEditor',{ref:"ue"}),_c('button',{on:{"click":function($event){return _vm.getContent()}}},[_vm._v("获取内容")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }